import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import useTranslationSharie from "../Language/useTranslation"

function NavigationListener() {
  const location = useLocation()
  const t = useTranslationSharie()

  useEffect(() => {
    if (location.pathname !== "/home") {
      let pathName = location.pathname
        .replace("/", "")
        .split("/")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ")

      if (location.pathname === "/") document.title = `Sharie - ${t("Login")}`
      else document.title = `Sharie - ${t(pathName)}`
    } else {
      document.title = `Sharie - ${t("Home")}`
    }
  }, [location])

  return null
}

export default NavigationListener
